<template>
  <nav>
    <ul class="progress">
      <li
        v-for="item in progressList"
        :key="item.type"
        class="progress-bar"
        :class="{
          'active': item.type === step,
          'finished': item.type < step,
        }"
      >
        <span class="progress-bar__number">{{ item.type + 1 }}</span>
        <span class="progress-bar__icon"><i class="fa fa-check" aria-hidden="true" /></span>
        <p class="progress-bar__name">{{ item.typeName }}</p>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: ['step'],
  data() {
    return {
      progressList: [],
    };
  },
  created() {
    this.progressList = [
      {
        typeName: this.$t('shopping.progress.cart'),
        type: 0,
      },
      {
        typeName: this.$t('shopping.progress.fillData'),
        type: 1,
      },
      {
        typeName: this.$t('shopping.progress.confirmCheckout'),
        type: 2,
      },
      {
        typeName: this.$t('shopping.progress.payment'),
        type: 3,
      },
      {
        typeName: this.$t('shopping.progress.orderComplete'),
        type: 4,
      },
    ];
  },
};
</script>

<style lang="scss" scoped>
.progress {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;

  &-bar {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 30px;

    @media (max-width: 767px) {
      padding: 0 15px;
    }

    &:nth-child(n + 2) {
      &::before {
        content: "";
        position: absolute;
        top: 20px;
        right: 100%;
        display: block;
        width: 90px;
        height: 2px;
        background-color: #eee;
        transform: translateX(50%);
        z-index: 0;

        @media (max-width: 767px) {
          top: 15px;
          width: 40px;
        }
      }
    }

    &__number {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 40px;
      margin-bottom: 10px;
      font-weight: 700;
      color: #999;
      background-color: #fff;
      border: 2px solid #aaa;
      border-radius: 50%;
      z-index: 1;

      @media (max-width: 767px) {
        width: 30px;
        height: 30px;
        margin-bottom: 0;
      }
    }

    &__icon {
      position: relative;
      display: none;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 40px;
      margin-bottom: 10px;
      font-weight: 700;
      color: #fff;
      background-color: #9ee630;
      border: 2px solid var(--custom-light-color);
      border-radius: 50%;
      z-index: 1;

      @media (max-width: 767px) {
        width: 30px;
        height: 30px;
        margin-bottom: 0;
      }
    }

    &__name {
      color: #333;
      font-weight: 700;
      font-size: 15px;

      @media (max-width: 767px) {
        display: none;
      }
    }

    &.active {
      .progress-bar__number {
        color: var(--second-color);
        border-color: var(--second-color);
      }

      .progress-bar__name {
        color: var(--second-color);
      }
    }

    &.finished {
      .progress-bar__number {
        display: none;
      }

      .progress-bar__icon {
        display: flex;
      }
    }

    &.active, &.finished {
      &::before {
        background-color: var(--custom-light-color);
      }
    }
  }
}
</style>
